export default __webpack_public_path__ + "static/logo.gsk-gebro-09ff892669c6789c7a0c7f47cd269618.png";